import { format } from "date-fns";
import api from "../services/api";

interface IAgentOpenedResponse {
    codeResult: string;
    data: any[];
}

export interface IAgentOpenedParams {
    mensal: boolean;
    year: string;
    month: string;
    tipo: string;
    statusKit: string;
    liberacao: string;
    prorrogado: string;
    regionalId: string;
    sectorId: string;
    agentId: string;

}
export interface IAgentOpened {
    gerenteSetor: string;
    representante: string;
    acerto: string;
    quantidade: number;
    tipo: number;
}


class AgentOpenedRepository {
    public async Opened({ mensal, month, year, tipo, statusKit, liberacao, prorrogado, regionalId, sectorId, agentId }: IAgentOpenedParams): Promise<IAgentOpened[]> {
        var initialDate = "";
        var endDate = "";
        if (mensal === true) {
            initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
            endDate = format(new Date(parseInt(year), parseInt(month), 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        }
        else {
            initialDate = format(new Date(parseInt(year), 0, 1, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
            endDate = format(new Date(parseInt(year), 11, 16, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        }

        const body = {
            "tables": ["Kit", "Representante", "Pedido", "GerenteSetor"],
            "sql": [
                {
                    "coderesult": "Opened",
                    "query": `SELECT GerenteSetor.nome as GS, 
                    Representante.nome as RP,
                    Representante.id as IdRep, 
                    Pedido.acerto as ACERTO,
                    COUNT(Kit.id) AS QTD, Kit.tipo as TIPO
                    FROM Kit
                    INNER JOIN Pedido
                    ON Pedido.id = Kit.pedidoId                    
                    INNER JOIN GerenteSetor
                    ON GerenteSetor.id  = Pedido.gerenteSetorId
                    LEFT JOIN Representante
                    ON Representante.id = Pedido.representanteId
                    WHERE Pedido.acerto >= '${initialDate}'
                    AND Pedido.acerto <= '${endDate}'
                    AND Kit.statusKit IN (${statusKit})
                    AND Kit.liberacao IN(${liberacao}) 
                    AND Kit.prorrogado IN(${prorrogado}) 
                    AND Kit.tipo IN(${tipo}) 
                    ${regionalId.length > 0 ? `AND Pedido.gerenteRegionalId = '${regionalId}' ` : ""}
                    ${sectorId.length > 0 ? `AND Pedido.gerenteSetorId = '${sectorId}' ` : ""}
                    ${agentId.length > 0 ? `AND Pedido.representanteId = '${agentId}' ` : ""} 
                    GROUP BY GerenteSetor.nome, 
                    Representante.nome,
                    Pedido.acerto, Kit.tipo 
                    ORDER BY GS, RP, ACERTO`
                }
            ]
        };

        const response = await api.post<IAgentOpenedResponse[]>("reports", body);
        console.log(response);

        return this.GetFromCodeResult(response.data, "Opened").map(result => {
            return {
                gerenteSetor: result.GS,
                representante: result.RP,
                acerto: result.ACERTO,
                quantidade: result.QTD,
                tipo: result.TIPO
            }
        });
    }

    GetFromCodeResult(data: IAgentOpenedResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const agentOpenedRepository = new AgentOpenedRepository();
export default agentOpenedRepository;